import React, {Component} from 'react';
import {Link} from 'react-router';
import $ from 'jquery';
import cx from 'classnames';
import validator from 'validator';

const selectOptions = [
    'Google or other search',
    'Word of mouth',
    'Advertisement',
    'Article or blog post',
    'Social media',
    'Event or webinar',
    'Other'
];

export default class BrandSignup extends Component {
    constructor(props) {
        super(props);
        this.displayHeader = this.displayHeader.bind(this);
        this.state = {
            email: '',
            fullName: '',
            brandName: '',
            source: '',
            questions: '',
            cc: 'brianz@socialnative.com,jeffr@socialnative.com,hunters@socialnative.com',
            isEmailValid: true,
            isFullNameValid: true,
            isBrandNameValid: true,
            isSourceValid: true
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        const {email, fullName, brandName, source, questions, cc} = this.state;
        const {page, displayThankYou} = this.props;

        if (this.isValid()) {
            $.ajax({
                url: 'https://formspree.io/bhajii@socialnative.com',
                method: 'POST',
                data: {
                    contact: email,
                    fullName: fullName,
                    brandName: brandName,
                    source: source,
                    questions: questions,
                    page: page,
                    _cc: cc,
                    _subject: `${brandName}: New submission from socialnative.com`
                },
                dataType: 'json',
                success: function(data) {
                    this.resetForm();
                    displayThankYou();
                }.bind(this),
                error: function(xhr, status, err) {
                    console.log('Sorry, the following error happened: ', err);
                }.bind(this)
            });
        }
    };

    resetForm = () => {
        this.setState({
            email: '',
            fullName: '',
            brandName: '',
            source: '',
            questions: ''
        });
    }

    handleEmailChange = e => this.setState({email: e.target.value});

    handleFullNameChange = e => this.setState({fullName: e.target.value});

    handleBrandNameChange = e => this.setState({brandName: e.target.value});

    handleQuestionsChange = e => this.setState({questions: e.target.value});

    handleSourceChange = e => this.setState({source: e.target.value});

    validateEmail() {
        const isBusinessEmail = !/@(gmail|yahoo)\.com$/.test(this.state.email);
        let valid = validator.isEmail(this.state.email) && isBusinessEmail;
        this.setState({isEmailValid: valid, isBusinessEmail});
        return valid;
    }

    validateFullName() {
        const valid = !!(this.state.fullName && this.state.fullName.length > 2);
        this.setState({isFullNameValid: valid});
        return valid;
    }

    validateBrandName() {
        const valid = !!(this.state.brandName && this.state.brandName.length > 2);
        this.setState({isBrandNameValid: valid});
        return valid;
    }

    validateSource() {
        const valid = !!(this.state.source);
        this.setState({isSourceValid: valid});
        return valid;
    }

    isValid() {
        const validEmail = this.validateEmail();
        const validFullName = this.validateFullName();
        const validBrandName = this.validateBrandName();
        const validSource = this.validateSource();

        return validEmail && validFullName && validBrandName && validSource;
    }

    displayHeader(){
        const {page, displayStatic} = this.props;
        const brandSignupHeaderClassnames = cx('brand-signup-header', {
            'brand-signup-header-web-static': displayStatic
        });

        return page === 'brand-ambassadors' ? (
            <div className='brand-signup-header'>
                <h3>
                    Contact Social Native Today
                </h3>
                <div className='blue-line-divider'></div>
            </div>
        ) : (
            <div className={brandSignupHeaderClassnames}>
                <h3>
                    Drive sales by creating beautiful, personalized and highly targeted branded content
                </h3>
                <div className='blue-line-divider'></div>
            </div>
        );
    }

    render() {
        const {email, fullName, brandName, source, questions, isEmailValid, isFullNameValid, isBrandNameValid, isSourceValid, isBusinessEmail} = this.state;
        const {page} = this.props;
        const header = this.displayHeader();

        return (
            <div className="brand-signup">
                <div>
                    {header}
                    <form role="form"
                          onSubmit={this.handleSubmit}
                          acceptCharset="UTF-8">
                        <div className={cx("form-group", !isFullNameValid && 'invalid')}>
                            <label htmlFor="full-name">
                                First and Last Name (required)
                            </label>
                            <div className="input-group">
                                <input className="form-control"
                                       onChange={this.handleFullNameChange}
                                       value={fullName}
                                       type="text"
                                       name="fullName"
                                       id="full-name"/>
                            </div>
                        </div>
                        <div className={cx("form-group", !isEmailValid && 'invalid')}>
                            <label htmlFor="email">
                                Company Email (required)
                            </label>
                            <div className="input-group">
                                <input className="form-control"
                                       onChange={this.handleEmailChange}
                                       value={email}
                                       type="text"
                                       name="_replyto"
                                       id="email"/>
                            </div>
                        </div>
                        <div className={cx("form-group", !isBrandNameValid && 'invalid')}>
                            <label htmlFor="brand-name">
                                Company (required)
                            </label>
                            <div className="input-group">
                                <input className="form-control"
                                       onChange={this.handleBrandNameChange}
                                       value={brandName}
                                       type="text"
                                       name="brandName"
                                       id="brand-name"/>
                            </div>
                        </div>
                        <div className={cx("form-group", !isSourceValid && 'invalid')}>
                            <label htmlFor="source">
                                How did you hear about us? (required)
                            </label>
                            <div className="input-group">
                                <select className="form-control"
                                        onChange={this.handleSourceChange}
                                        value={source}
                                        name="source"
                                        id="source">
                                    <option />
                                    {selectOptions.map((option, i) => (
                                        <option value={option} key={i}>{option}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className={cx("form-group", !isEmailValid && 'invalid')}>
                            <label htmlFor="questions">
                                Questions or Comments
                            </label>
                            <div className="input-group">
                                <input className="form-control"
                                       onChange={this.handleQuestionsChange}
                                       value={questions}
                                       type="text"
                                       name="questions"
                                       id="questions"/>
                                <input
                                    type="hidden"
                                    name="page-accessed"
                                    value={page} />
                                <input
                                    type="hidden"
                                    name="_cc"
                                    value="bhajii@socialnative.com" />
                            </div>
                        </div>

                        <button className="btn" type="submit">
                            Get Started
                        </button>
                        {!isBusinessEmail && !isEmailValid && <div className="error">Please use an email on your business domain.</div>}
                        <div className='contact-form-creator-link'>
                            <Link to="/content_creator">Are you a content creator? Click here.</Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_signup.js